// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"7a1800bf06eda919fdd3","293":"8cebe241242dd93b5516","518":"72a2860241ea2bac44a1","779":"b871d38d74f893ac92ca"}[chunkId] + ".js";
};